import moment, {Moment} from 'moment';

import {formatDate} from 'common/util/date';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';
import {Timezone} from 'common/constants';

export const ANNOTATION_GROUP_DATE_CUSTOM_FORMATTING = {[TimeUnit.Day]: `ddd, MMM D`};

export function parseAnnotationDate(isoDate: string): Moment {
  // retain the timezone info in the iso date (for later formatting, etc...)
  // assume your browser is in PDT
  // moment(`2025-08-01T12:00:00-05:00`).format() -> 2025-08-01T10:00:00-07:00
  // moment.parseZone(`2025-08-01T12:00:00-05:00`).format() -> 2025-08-01T12:00:00-05:00
  return moment.parseZone(isoDate, moment.ISO_8601);
}

export function formatAnnotationDateForGroup(
  isoDate: string,
  {timezone, timeUnit}: {timezone: Timezone; timeUnit?: TimeUnit},
) {
  timeUnit = timeUnit ?? TimeUnit.Day;
  return formatDate(parseAnnotationDate(isoDate), {
    unit: timeUnit,
    displayRangeIfWeek: true,
    customFormatting: ANNOTATION_GROUP_DATE_CUSTOM_FORMATTING,
    timezone,
    hideTimezone: true,
  });
}

export function formatAnnotationDate(isoDate: string, {timezone, timeUnit}: {timezone: Timezone; timeUnit?: TimeUnit}) {
  const dateMoment = parseAnnotationDate(isoDate);
  return formatDate(dateMoment, {
    unit: timeUnit,
    customFormatting: {[timeUnit as string]: `MMM Do, YYYY h:mma`},
    timezone,
    hideTimezone: true,
  });
}
